<script>
    export let type = 'text'
    export let placeholder = ''
    export let value = ''
    export let size = ''
    export let disabled = false
    export let className = ''
</script>

<style lang="scss">
    input {
        height: 40px;
        border-radius: 30px;
        background-color: #2e322f;
        border: none;
        line-height: 40px;
        font-family: Roboto;
        font-size: 12px;
        letter-spacing: 0.2px;
        color: #ffffff;
        padding: 0 20px;
        width: 100%;
        margin: 0;
        &.big {
            height: 60px;
            font-size: 15px;
            line-height: 60px;
            letter-spacing: 0.04px;
        }
        &.danger {
            border: 1px solid #df4937
        }
        &.warning {
            border: 1px solid #cd7623
        }
    }
</style>

<input class={className + ' ' + size} {type} {value} {placeholder} {disabled} on:change />
